import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getRecipeRequiredSecrets } from '@src/app/recipe/utils';
import { selectCurrentRecipe } from '@src/features/Workspace/workspaceSlice';
import { selectCurrentWidgets } from '@src/features/LogicMapper/logicMapperSlice';

/**
 * Custom hook that determines if the current recipe has any required secrets.
 * 
 * @returns boolean indicating whether the recipe has required secrets
 */
const useRecipeHasRequiredSecrets = (): boolean => {
  const [hasRequiredSecrets, setHasRequiredSecrets] = useState<boolean>(false);
  const currentRecipe = useSelector(selectCurrentRecipe);
  const currentWidgets = useSelector(selectCurrentWidgets);

  useEffect(() => {
    if (!currentRecipe?.poolId) {
      setHasRequiredSecrets(false);
      return;
    }

    try {
      const requiredSecrets = getRecipeRequiredSecrets(currentRecipe.poolId);
      setHasRequiredSecrets(requiredSecrets.length > 0);
    } catch (error) {
      console.error('Error checking recipe required secrets:', error);
      setHasRequiredSecrets(false);
    }
  }, [currentRecipe?.poolId, currentWidgets]);

  return hasRequiredSecrets;
};

export default useRecipeHasRequiredSecrets;
